import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) => theme.bg1};
  box-shadow: ${({ theme }) => theme.darkMode ? 'none' : '0px 1px 10px rgba(168, 121, 0, 0.13)'};
  border-radius: 40px;
  overflow: hidden;
  margin-top: 12px;
  padding: 32px 0;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `}
`
const Title = styled.div`
  color: ${({ theme }) => theme.primary1};
  margin: 0 0 16px;
  font-family: Yuanti SC;
  font-size: 18px;
  font-weight: 700;
`
const Title1 = styled(Title)`
  margin: 32px 0 26px;
`
const ImgEgg = styled.img`
  width: 157px;
  height: auto;
  margin-bottom: 25px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-bottom: 16px;
  `}
`


export default function NoEgg({noText, noImg}: {noText?: String, noImg: any}) {
  return (
    <Wrapper>
        <Title1>{noText}</Title1>
        {
          noImg ? 
          <ImgEgg src={ noImg } alt="unknown-pets"/>
          : <></>
        }
        </Wrapper>
  )
}